// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".data-visual-bar-map[data-v-62e05461]{transform:scale(.75) translateY(3rem)}.tabs[data-v-62e05461]{display:flex;justify-content:center}.map-wrapper[data-v-62e05461]{display:flex;height:340px}.map-wrapper .map[data-v-62e05461]{display:flex;justify-content:center;align-items:center;position:relative}.map-wrapper .label[data-v-62e05461]{color:#7c858e;font-size:1.4rem;position:absolute;bottom:0}", ""]);
// Exports
module.exports = exports;
